import { MenteeStatusValues } from 'enums/MenteeStatus';
import { FC, useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { MenteeEditContext } from '.';
import GeneralInformation from './GeneralInformation';
import Interviews from './interviews';
import MenteeForm from './MenteeForm';
import Mentoring from './Mentoring';
import Associate from './Mentoring/Associate';
import MenteeTracking from './Mentoring/tracking';

const MenteeProfileRoutes: FC = () => {
  const { mentee } = useContext(MenteeEditContext);

  return (
    <Routes>
      <Route path="" element={<GeneralInformation />} />
      <Route path="/form/" element={<MenteeForm />} />
      <Route
        path="/mentoring/*"
        element={
          (
            ['ELIGIBLE', 'MENTORSHIP_ACTIVE', 'REFUSED'] as MenteeStatusValues[]
          ).includes(mentee?.menteeStatus as MenteeStatusValues) ? (
            <Mentoring />
          ) : (
            <div>
              La partie Mentorat n'est pas disponible pour cet utilisateur.
            </div>
          )
        }
      />
      <Route path="/mentoring/associate" element={<Associate />} />
      <Route path="/interviews" element={<Interviews />} />
      <Route path="/tools" element={<div>e</div>} />
      <Route path="/transaction-history" element={<div>f</div>} />
      <Route path="/tracking" element={<MenteeTracking />} />
    </Routes>
  );
};

export default MenteeProfileRoutes;
